import { render, staticRenderFns } from "./ClaimsValueContractorChart.vue?vue&type=template&id=fff33e86&scoped=true"
import script from "./ClaimsValueContractorChart.vue?vue&type=script&lang=js"
export * from "./ClaimsValueContractorChart.vue?vue&type=script&lang=js"
import style0 from "./ClaimsValueContractorChart.vue?vue&type=style&index=0&id=fff33e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff33e86",
  null
  
)

export default component.exports